import React, { Component } from "react";

import { BrowserRouter as Router, Redirect } from "react-router-dom";
import  WebServiceList  from '../webservices/WebServiceList'

import axios from 'axios';
export default class Logout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    }

  }

    renderRedirect = () => {
      console.log("!!!!!! renderRedirect")
      if (this.state.redirect) {
        console.log("REDIRECT TO LOGIN")
        return <Redirect to='/login' />
      }
    }
  
    componentDidMount() {
  
      const isLoggedIn = localStorage.getItem("loggedIn");
      const theToken = localStorage.getItem("token");
     
      const headers = {
        'Content-Type': 'application/json',
        'x-access-token': theToken,
      };
  
      console.log("--------> token:" + theToken);
      console.log("-------> isLoggedIn:" + isLoggedIn);
      if (isLoggedIn===false) {
        console.log("REDIRECT TRUE:");
        this.setState({
          redirect: true
        })
      } else {
        console.log("CALL AXIOS getAdminInfo:");
       
        axios.get(WebServiceList.WsLogout())
          .then(res => {
            console.log("componentDidMount " + JSON.stringify(res.data));
              localStorage.setItem("token", "");
              localStorage.setItem("AdminId", "");
              localStorage.setItem("AdminEmail", "");
              localStorage.setItem("AdminName", "");
              localStorage.setItem("AdminRole", "");
              localStorage.setItem("loggedIn", false);
              this.setState({
                redirect: true
              })
          });
  
      }
    }

  render() {
    return (<div >
      {this.renderRedirect()}

    </div>);
  }
}

